import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "emptybms__container"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label mb-2" }, "Profile Linking", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "info mb-3" }, [
  /*#__PURE__*/_createTextVNode("Facebook pulls in Business Manager, Pages, and any Instagram accounts linked to those Pages."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Instagram connects just your standalone Professional account. ")
], -1)
const _hoisted_4 = { class: "info mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "gap-2 emptybms__buttons" }

import { useFacebookStore } from '@/stores/facebook';
import { useUiStore } from '@/stores/ui';
import { useDialogStore } from '@/stores/dialogs';
import { useTiktokStore } from '@/stores/tiktok';
import VButton from './VButton.vue';
import FacebookIcon from '@/components/icons/other/FacebookIcon.vue'
import TiktokIcon from '@/components/icons/other/TiktokIcon.vue'
import ArrowRightIcon from './icons/navigation/ArrowRightIcon.vue';
import SettingsDialog from './dialogs/SettingsDialog.vue';
import InstagramIcon from './icons/other/InstagramIcon.vue';
import { useAccountStore } from '@/stores/account';
import { useInstagramStore } from '@/stores/instagram';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyBMs',
  setup(__props) {

const uiStore = useUiStore()
const facebookStore = useFacebookStore()
const instagramStore = useInstagramStore()
const tiktokStore = useTiktokStore()
const accountStore = useAccountStore()

const dialog = useDialogStore()

const openSettings = () => {
  dialog.open(SettingsDialog)
}

const openSettingsSocial = () => {
  dialog.open(SettingsDialog, { page: "social" })
}


return (_ctx: any,_cache: any) => {
  return (_unref(uiStore).showBM)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode("Need to tweak this later? Jump into"),
          _hoisted_5,
          _createElementVNode("a", { onClick: openSettings }, "Settings"),
          _createVNode(ArrowRightIcon),
          _createElementVNode("a", { onClick: openSettingsSocial }, "Assets")
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VButton, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(facebookStore).connectFacebook()))
          }, {
            default: _withCtx(() => [
              _createVNode(FacebookIcon),
              _createTextVNode("Connect Facebook")
            ]),
            _: 1
          }),
          _createVNode(VButton, {
            class: "instagram",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(instagramStore).connectInstagram()))
          }, {
            default: _withCtx(() => [
              _createVNode(InstagramIcon),
              _createTextVNode("Connect Instagram")
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})